export const Environment = {
  ENVIRONMENT: import.meta.env.VITE_APP_ENVIRONMENT ?? 'development',
  POSITO_ENVIRONMENT: import.meta.env.VITE_APP_POSITO_ENVIRONMENT ?? 'dev',
  FIREBASE_PUBLIC_API_KEY: import.meta.env.VITE_APP_FIREBASE_PUBLIC_API_KEY ?? 'dev',
  FIREBASE_AUTH_DOMAIN: import.meta.env.VITE_APP_FIREBASE_AUTH_DOMAIN ?? 'dev',

  isDevelopment: () => {
    return import.meta.env.VITE_APP_ENVIRONMENT === 'development';
  },

  isPositoDevelopment: () => {
    return import.meta.env.VITE_APP_POSITO_ENVIRONMENT === 'dev';
  },

  DEV_API_URL: import.meta.env.VITE_APP_DEV_API_URL ?? undefined,
  DEV_GO_API_URL: import.meta.env.VITE_APP_DEV_GO_API_URL ?? undefined,
};
